import $, { extend } from 'jquery';
import 'react-bootstrap/dropdown';
import Popper from 'popper.js';
//import {Popper} from '@popperjs/core';
import React from 'react';

import "jquery-ui-bundle/jquery-ui";
import "jquery-ui-bundle/jquery-ui.css";

import 'react-bootstrap/modal';

import 'react-bootstrap/tooltip';

import {UserToken,getUserObjData,getAccessFunctions,getCol3} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker,
  btnSetColor_CBack} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from './header';
import Footer from './footer';


import defaultPic from '../assets/images/9.png';

import Comp_Class_Fee_Master from '../components/comp_class_fee_master';
import Comp_Edit_Student_Basic from '../components/comp_edit_student_basic';
import Comp_Edit_Student_Family from '../components/comp_edit_student_family';
import Comp_Edit_Student_Auth from '../components/comp_edit_student_auth';

import Comp_Edit_Full_Student from '../components/comp_edit_full_student';
import Comp_View_Student_Card from '../components/comp_view_student_card';
import Comp_Print_Student from '../components/comp_print_student';

import Comp_Marksheet_Pro_One from '../components/comp_marksheet_pro_one';
import Comp_Marksheet_Bulk_Print_High_Cls from '../components/comp_marksheet_bulk_print_high_cls';
import Comp_Marksheet_Bulk_Print from '../components/comp_marksheet_bulk_print';

//import Comp_Marksheet_Bulk_Print_V2 from '../component_marksheet/comp_marksheet_bulk_print_v2';

//import Comp_Marksheet_Pro_One from '../components/comp_marksheet_pro_one_primary';

let loginUser="";
let userObject="";
let companyName="";
let clsStudentAdmission;

let rf="0";
window.Popper = Popper;

let genderList=["M.","F."];
let castCategoryList=["GEN","OBC","SC","ST"];
let _objAccess={};
class Class_Wise_Marksheet extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
          _objAccess=getAccessFunctions();
      }
      this.state={ stListBranches:[],stListClassFee:[],stListSessionYear:[],stListClassMaster:[],
        stListFeeCategory:[],stLsStudentBasic:[],stLsStudentFamily:[],stLsStudentAuth:[],
        stLsFullStudentDet:{},
        stStudentId:"0",
        stIsHighClass:"0",
      stEditItem:{},stStudentPrintMarks:{},stStudentPrintMarksBulk:[],stSubjectMarks:[]};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsStudentAdmission=this;
      }
//******  for child component function

editStudentBasic(frmName){
  btnSetColor_CBack(this,frmName,"updateStudentBasic",function(data,msg){
      if(data==="001"){
        //window.location.reload();
          alert("Updated Successfully");
          //clsStudentAdmission.getStudentAdmission();
      }
  })
}
editStudentFamily(frmName){
  btnSetColor_CBack(this,frmName,"updateStudentFamily",function(data,msg){
    if(data==="001"){
      //window.location.reload();
        alert("Updated Successfully");
        //clsStudentAdmission.getStudentAdmission();
    }
})
}
editStudentAuth(frmName){
  btnSetColor_CBack(this,frmName,"updateStudentAuth",function(data,msg){
    if(data==="001"){
      //window.location.reload();
        alert("Updated Successfully");
        //clsStudentAdmission.getStudentAdmission();
    }
})
}

//**** end of child component function

calculateRanks(){
 
  let map=[];

  map.push({name:"curl_type",value:"autoSetTopRank"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"user_type",value:userObject[0].type});
  map.push({name:"ser_session_year",value:$("#ser_session_year").val()});
  map.push({name:"ser_class_name",value:$("#ser_class_name").val()});
  map.push({name:"ser_section",value:$("#ser_section").val()});
  
  map.push({name:"ser_branches",value:$("#ser_branches").val()});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="autoSetTopRank";

  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    if(data==="001"){
      alert("Rank I,II,III calculated successfully");
    }
  })

}

getStudentClassMarks(){
    let map=[];
    map.push({name:"curl_type",value:"generateMarksByClassSection"});
    map.push({name:"res_func",value:"callBackrrr"});
    map.push({name:"local_token",value:userObject[0].app_user_id});
    map.push({name:"user_type",value:userObject[0].type});
    map.push({name:"ser_session_year",value:$("#ser_session_year").val()});
    map.push({name:"ser_class_name",value:$("#ser_class_name").val()});
    map.push({name:"ser_section",value:$("#ser_section").val()});
    map.push({name:"ser_admission_type",value:$("#ser_admission_type").val()});
    
    map.push({name:"ser_branches",value:$("#ser_branches").val()});
    map.push({name:"ser_stu_status",value:$("#ser_stu_status").val()});
    
    map["res_func"]="callBackrrr";
    map["curl_type"]="generateMarksByClassSection";

    CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
      //alert(data);
        if(data!=="" && data!=="0"){
            let listData=JSON.parse(data);
           
            //alert(listData.ls_student_results);
            clsStudentAdmission.setState({stStudentPrintMarksBulk:listData.ls_student_results});
        }
    })


}

OnClassChange(){
  //alert("i min clla");
  let classId=$("#ser_class_name").val();
  let isHigclass="0";
  if(parseInt(classId)>11){
    isHigclass="1";
  }
  clsStudentAdmission.setState({stIsHighClass:isHigclass},()=>{
    clsStudentAdmission.forceUpdateHandler();
  })
}





      getStudentAdmission(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getStudentAdmission"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"ser_session_year",value:$("#ser_session_year").val()});
        map.push({name:"ser_class_name",value:$("#ser_class_name").val()});
        map.push({name:"ser_section",value:$("#ser_section").val()});
        map.push({name:"ser_admission_type",value:$("#ser_admission_type").val()});
        
        map.push({name:"ser_branches",value:$("#ser_branches").val()});
        map.push({name:"ser_stu_status",value:$("#ser_stu_status").val()});
        
        map["res_func"]="callBackrrr";
        map["curl_type"]="getStudentAdmission";
        CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                $(".outstanding_rpt").html("Total :"+listData.length+" Records Found");
                
                clsStudentAdmission.setState({stListClassFee:listData},()=>{
                  //window.getPagination("#tbData");
                  clsStudentAdmission.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                });
              }
        });
      }
      okSucc(data,smg){
        if(data==="001"){
          //alert("record added successfully");
          Custom_Alert("Successful","Record Added Successfully",true);
          clsStudentAdmission.getClassMaster();
          $("#frmCreate").find("input[type=text]").val("");
        }else{
          //alert(smg);
          Custom_Alert("Not Working",smg,false);
        }
        // alert(data);
      }
stubasic_okSucc(data,msg){
  alert(data);
}

onDeleteStudentSys(item){
  if(window.confirm("Confirm! Do you want delete particular student from system?")){
    let map=[];
    map.push({name:"curl_type",value:"deleteWhStudent"});
    map.push({name:"res_func",value:"callBackrrr"});
    map.push({name:"local_token",value:userObject[0].app_user_id});
    map.push({name:"user_type",value:userObject[0].type});
    map.push({name:"stu_id",value:btoa(item.id)});
    //alert($("#ser_session_year").val());
    //map.push({name:"upper_id",value:userObject[0].upper_id});
    map["res_func"]="callBackrrr";
    map["curl_type"]="deleteWhStudent";
    CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
      if(data==="001"){
        alert(msg);
        window.location.reload();
      }
    })
  }
  
}

onGetPrintMarksData(item){
  let map=[];
  map.push({name:"curl_type",value:"printByStudent"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"user_type",value:userObject[0].type});
  map.push({name:"stu_id",value:btoa(item.id)});

  map.push({name:"class_id",value:$("#ser_class_name").val()});
  map.push({name:"session_year_id",value:$("#ser_session_year").val()})
  //alert($("#ser_session_year").val());
  //map.push({name:"upper_id",value:userObject[0].upper_id});
  map["res_func"]="callBackrrr";
  map["curl_type"]="printByStudent";
  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    // alert("i m in setup");
    // alert(data);
    if(data!=="0"){
      let lsData=JSON.parse(data);
      clsStudentAdmission.setState({stLsStudentBasic:lsData.ls_stu_basic,
        stStudentId:item.id,stEditItem:item,
        stStudentPrintMarks:lsData.ls_stu_exams,
      stSubjectMarks:lsData.ls_subject_marks},()=>{
        clsStudentAdmission.forceUpdateHandler();
      })
    }
  })
}

onStudentDetailsEdit(item){
  let map=[];
  map.push({name:"curl_type",value:"getMastStudentData"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"user_type",value:userObject[0].type});
  map.push({name:"stu_id",value:btoa(item.id)});
  //alert($("#ser_session_year").val());
  //map.push({name:"upper_id",value:userObject[0].upper_id});
  map["res_func"]="callBackrrr";
  map["curl_type"]="getMastStudentData";
  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    //alert(data);
    if(data!=="0"){
      let lsData=JSON.parse(data);
      clsStudentAdmission.setState({stLsStudentBasic:lsData.ls_stu_basic,
      stLsStudentFamily:lsData.ls_stu_family,stLsStudentAuth:lsData.ls_stu_auth,
      stStudentId:item.id,stLsFullStudentDet:lsData,stEditItem:item},()=>{
        clsStudentAdmission.forceUpdateHandler();
      })
    }
  })
}

getMasters(){
  var map=[];
  map.push({name:"curl_type",value:"getMastersRequest"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"branch_acc",value:getCol3()});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getMastersRequest";
  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    //alert(data);
      if(data!=="0" && data!==""){
          let listData=JSON.parse(data);
          var strData="";
          //alert(JSON.stringify(listData.master_balance));
          clsStudentAdmission.setState({
            stListSessionYear:listData.ls_session_year,
            stListClassMaster:listData.ls_class_master,
          stListFeeCategory:listData.ls_fee_category,
        stListBranches:listData.ls_branches},()=>{
            clsStudentAdmission.forceUpdateHandler();
          })
        }
  });
}
          
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
//this.getStudentAdmission();
this.getMasters();

$('#divEditFullStudent').on('hidden.bs.modal', function () {
  //window.location.reload();
  $("#frmEditFullStudent")[0].reset();
  clsStudentAdmission.setState({stLsStudentBasic:[],
    stLsFullStudentDet:{},
    stStudentId:"0"},()=>{
      clsStudentAdmission.forceUpdateHandler();
    });
  clsStudentAdmission.getStudentAdmission();
});

$('#divEditStudentBasic').on('hidden.bs.modal', function () {
 // window.location.reload();
  $("#frmEditStudentBasic")[0].reset();
  clsStudentAdmission.setState({stLsStudentBasic:[],
    stLsStudentFamily:[],stLsStudentAuth:[],
    stStudentId:"0"},()=>{
      clsStudentAdmission.forceUpdateHandler();
    });
  //clsStudentAdmission.getStudentAdmission();
});
$('#divEditStudentFamily').on('hidden.bs.modal', function () {
  //window.location.reload();

  //alert("reset state");
  // clsStudentAdmission.setState({stLsStudentBasic:[],
  //   stLsStudentFamily:[],stLsStudentAuth:[],
  //   stStudentId:"0"},()=>{
  //     clsStudentAdmission.forceUpdateHandler();
  //   });
  //$("#frmEditStudentFamily")[0].reset();
  clsStudentAdmission.getStudentAdmission();
});
$('#divEditStudentAuth').on('hidden.bs.modal', function () {
  //window.location.reload();

  // clsStudentAdmission.setState({stLsStudentBasic:[],
  //   stLsStudentFamily:[],stLsStudentAuth:[],
  //   stStudentId:"0"},()=>{
  //     clsStudentAdmission.forceUpdateHandler();
  //   });
  //$("#frmEditStudentAuth")[0].reset();

  clsStudentAdmission.getStudentAdmission();
});

}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row content12 mt-2 mb-2">
{/* for now [row]it is unused */}
{/* starting of cols */}

<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <select id="ser_session_year" name="ser_session_year" className="form-control form-control-sm">
                <option value={"0"}>-Session Year-</option>
                {this.state.stListSessionYear.map((item,index)=>{
                  return <option value={item["id"]}>{item["session_name"]}</option>
                })}

               </select>
             </div>
         
         </div>
</div>
<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <select id="ser_branches" name="ser_branches" className="form-control form-control-sm">
                {this.state.stListBranches.length>1?<option value={btoa("0")}>-All-</option>:''}
                
                {this.state.stListBranches.map((item,index)=>{
                  return <option value={btoa(item["id"])}>{item["branch_name"]}</option>
                })}
               </select>
             </div>
         
         </div>
</div>


<div className='col-lg-1 col-md-1 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <select onChange={()=>this.OnClassChange()} id="ser_class_name" name="ser_class_name" className="form-control form-control-sm">
                <option value={"0"}>-Classes-</option>
                {this.state.stListClassMaster.map((item,index)=>{
                  return <option value={item["id"]}>{item["class_name"]}</option>
                })}

               </select>
             </div>
         
         </div>
</div>

<div className='col-lg-1 col-md-1 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <select id="ser_section" name="ser_section" className="form-control form-control-sm">
                <option value={"0"}>-Section-</option>
                <option value={"A"}>-A-</option>
                <option value={"B"}>-B-</option>
                <option value={"C"}>-C-</option>
                <option value={"D"}>-D-</option>
               </select>
             </div>
         
         </div>
</div>

<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <select id="ser_admission_type" name="ser_admission_type" className="form-control form-control-sm">
                <option value={"0"}>-Admission Type-</option>
                <option value="Regular">Regular Admission</option>
                <option value="RTE">RTE Admission</option>
</select>
             </div>
         
         </div>
</div>


<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <select id="ser_stu_status" name="ser_stu_status" className="form-control form-control-sm">
                <option value={"0"}>-Stu. Status-</option>
                <option value={"Active"}>Active</option>
                <option value={"Terminated"}>Terminated</option>
               </select>
             </div>
         
         </div>
</div>


<div className="col-lg-12 col-md-12 col-sm-12 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 <div onClick={()=>this.getStudentAdmission()}  style={{marginRight:"10px"}} className="btn btn-sm btn-danger">Search</div>

                 {this.state.stIsHighClass==="0"?
                 
                <button style={{marginRight:"10px"}} onClick={()=>this.getStudentClassMarks()} class="btn btn-sm btn-primary ml-2"  type="button" data-toggle="modal" data-target="#divPrintMarkSheetBulk" data-bs-toggle="modal" data-bs-target="#divPrintMarkSheetBulk">
        Generate Class Result
      </button>:<button style={{marginRight:"10px"}} onClick={()=>this.getStudentClassMarks()} class="btn btn-sm btn-primary ml-2"  type="button" data-toggle="modal" data-target="#divPrintMarkSheetBulk_high" data-bs-toggle="modal" data-bs-target="#divPrintMarkSheetBulk">
        Generate Class Result
      </button>
                }
                 


                 <div onClick={()=>window.location.reload()} className="btn btn-sm btn-danger">Reset</div>

                 <button style={{marginRight:"10px"}} onClick={()=>this.calculateRanks()} class="btn btn-sm btn-primary ml-2"  type="button">
        Calculate Rank (select sessionYear/Class and Section)
      </button>
                 </div>
               </div>
             </div>
</div>
{/* end of cols */}

    </div>    
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Student List</b></h3>
                <div className="outstanding_rpt float-left px-10"></div>
                <a className="btn btn-sm btn-danger float-right" href="../student_admission">Add New Student</a>
              </div>
              
                <Comp_View_Student_Card isMarksheet={true} getPrintMarksheet={this.onGetPrintMarksData} onEditClick={this.onStudentDetailsEdit} _objAccess={_objAccess} studentList={this.state.stListClassFee} />
            
              
             
                <div class='pagination-container' >
				<nav>
				  <ul class="pagination">
            
            <li data-page="prev" >
								     <span> {"<"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  
        <li data-page="next" id="prev">
								       <span> {">"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  </ul>
				</nav>
			</div>
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Alert_Content/>
<Footer/>
    {/* <Comp_Edit_Full_Student editFullStudentDet={this.state.stLsFullStudentDet} editItem={this.state.stEditItem} editStudentBasic={this.editStudentBasic} studentId={this.state.stStudentId} genderList={genderList} castCategoryList={castCategoryList} lsSessionYear={this.state.stListSessionYear} lsClassMaster={this.state.stListClassMaster} lsStudentBasic={this.state.stLsStudentBasic} app_user_id={userObject[0].app_user_id} />
    <Comp_Edit_Student_Basic editItem={this.state.stEditItem} editStudentBasic={this.editStudentBasic} studentId={this.state.stStudentId} genderList={genderList} castCategoryList={castCategoryList} lsSessionYear={this.state.stListSessionYear} lsClassMaster={this.state.stListClassMaster} lsStudentBasic={this.state.stLsStudentBasic} app_user_id={userObject[0].app_user_id} />
    <Comp_Edit_Student_Family editItem={this.state.stEditItem} editStudentFamily={this.editStudentFamily} studentId={this.state.stStudentId}  lsStudentFamily={this.state.stLsStudentFamily}/>
    <Comp_Edit_Student_Auth editItem={this.state.stEditItem} editStudentAuth={this.editStudentAuth} lsClassMaster={this.state.stListClassMaster} studentId={this.state.stStudentId} lsStudentAuth={this.state.stLsStudentAuth}/> */}
    <Comp_Print_Student _objAccess={_objAccess} lsTableData={this.state.stListClassFee} />
   
    <Comp_Marksheet_Pro_One studentSubjectMarks={this.state.stSubjectMarks} studentPrintMarks={this.state.stStudentPrintMarks} editItem={this.state.stEditItem}  lsStudentBasic={this.state.stLsStudentBasic}  />
    
    
    <Comp_Marksheet_Bulk_Print studentSubjectMarks={this.state.stSubjectMarks} studentPrintMarksBulk={this.state.stStudentPrintMarksBulk} />
<Comp_Marksheet_Bulk_Print_High_Cls studentSubjectMarks={this.state.stSubjectMarks} studentPrintMarksBulk={this.state.stStudentPrintMarksBulk} />
  
    
    
    {/* commmented on 14-02-2026 */}
    {/* <Comp_Marksheet_Bulk_Print studentSubjectMarks={this.state.stSubjectMarks} studentPrintMarksBulk={this.state.stStudentPrintMarksBulk} /> */}
    
    {/* <Comp_Marksheet_Bulk_Print_V2 studentSubjectMarks={this.state.stSubjectMarks} studentPrintMarksBulk={this.state.stStudentPrintMarksBulk}/> */}
    {/* <Comp_Class_Fee_Master lsSessionYear={this.state.stListSessionYear} lsClassMaster={this.state.stListClassMaster} lsFeeCategory={this.state.stListFeeCategory} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default Class_Wise_Marksheet;